import { UIComponentProps, UIComponentHandler, UIComponentImpl, UIComponentState } from '../../../toolkit/uicomponent';
import { ToneDto } from '../../../../core/dto/tonedto';
import { ShareToneDto } from '../../../../core/dto/sharetone/sharetonedto';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { ShareToneViewImpl } from './sharetoneview';
import { ShareToneCSSStyleImpl } from './sharetonecss';
import { ToneOptionsType } from '../tonedetailspopup/tonedetailspopupcomponent';

export interface ShareToneComponentProps extends UIComponentProps
{
    toneOptionsType: ToneOptionsType;
    toneDto: ToneDto;
    closePopup(): void;
    
}

export interface ShareToneComponentState extends UIComponentState
{
   isFacebookHovered: boolean;
   isTwitterHovered: boolean;
}

export interface ShareToneComponentHandler extends UIComponentHandler
{
    shareOnFaceBook(): void;
    shareOnTwitter(): void;
    onHovered(isFacebookHovered: boolean, isTwitterHovered: boolean):void;
    onHoveredExit():void;
}

export class ShareToneComponent extends UIComponentImpl<ShareToneComponentProps, ShareToneComponentState, ShareToneDto> 
implements ShareToneComponentHandler
{
    constructor(props: ShareToneComponentProps)
    {
        super(props);

        this.state = {isFacebookHovered : false, isTwitterHovered: false};
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<ShareToneDto>
    {
        return new ShareToneViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ShareToneCSSStyleImpl(applicationContext);
    }

    onHovered(isFacebookHovered: boolean, isTwitterHovered: boolean): void 
    {
        this.setState({isFacebookHovered: isFacebookHovered, isTwitterHovered});
    }

    onHoveredExit(): void {
        this.setState({isFacebookHovered: false, isTwitterHovered: false});
    }

    shareOnFaceBook(): void 
    {
        console.log("-----facebook: " + this.props.context.getProperty().getFaceBookURL());
       this.props.context.getProperty().getFaceBookURL()+ '?p[url]='
        +encodeURIComponent(this.props.toneDto.getToneUrl()) +
        '&p[image]='  + encodeURIComponent(this.props.toneDto.getImgPath()) 
        + '&p[title]='+this.props.toneDto.getToneName();
    }

    shareOnTwitter(): void 
    {
        console.log("-----twiiter: " + this.props.context.getProperty().getTwitterURL());
    //     this.props.context.getProperty().getTwitterURL()+ '?url='
    //   +encodeURIComponent(this.props.toneDto.getToneUrl()) 
    //   +'&site='+encodeURIComponent(this.props.context.getProperty().getTwitterAPPID()) + 'image=' 
    //   + encodeURIComponent(this.props.toneDto.getImgPath()) 
    //   + 'text='+this.props.toneDto.getToneName();
    }

    // sharefacebook()
    // {
    //     //  var title = 'My Title';
    //     // var summary = 'This is my summary';
    //     // //https://callertunes.etisalat.ae/PopulateSongs/AllTune?searchKey=313544&bannerTypeId=3&request_locale=en
    //     // var url = 'https://callertunes.etisalat.ae/PopulateSongs/AllTune?searchKey=313544&bannerTypeId=3&request_locale=en';
    //     // var image = 'http://10.0.0.27:8181/testtone/testimg.jpg';
    //     // var appid = '668572477041235';

    //     return this.props.context.getProperty().getFaceBookURL()+ '?p[url]='
    //     +encodeURIComponent(this.props.toneDto.getToneUrl()) 
    //     +'&p[app_id]='+encodeURIComponent(this.props.context.getProperty().getFaceBookAPPID()) + '&p[image]=' 
    //     + encodeURIComponent(this.props.toneDto.getImgPath()) 
    //     + '&p[title]='+this.props.toneDto.getToneName();
    // }

    // shareTwitter()
    // {
    // //   var site= "@Sixdee1";
    // //   var url = 'https://callertunes.etisalat.ae/PopulateSongs/AllTune?searchKey=313544&bannerTypeId=3&request_locale=en';
    // //   return 'https://twitter.com/intent/tweet?url='+encodeURIComponent(url) 
    // //   +'&via=getboldify&text=yourtext' + '&site=' + encodeURIComponent(site);

    //   return this.props.context.getProperty().getTwitterURL()+ '?url='
    //   +encodeURIComponent(this.props.toneDto.getToneUrl()) 
    //   +'&site='+encodeURIComponent(this.props.context.getProperty().getTwitterAPPID()) + 'image=' 
    //   + encodeURIComponent(this.props.toneDto.getImgPath()) 
    //   + 'text='+this.props.toneDto.getToneName();
    // }

  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/sharetone/sharetonecomponent.tsx